(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSProyectoCentralSolicitudController', SSProyectoCentralSolicitudController);

    SSProyectoCentralSolicitudController.$inject = ['$timeout', '$scope', '$state', '$uibModal', '$stateParams', 'entity', 'selectedTab', 'SSProyecto', 'SSArea', 'SSFuncion', 'SSModalidad', 'ProgramaEducativo', 'SSSector', 'SSAmbito', 'Sexo', 'SSMovimientoEstatusProyecto', 'SSEditarEstatusModalService'];

    function SSProyectoCentralSolicitudController ($timeout, $scope, $state, $uibModal, $stateParams, entity, selectedTab, SSProyecto, SSArea, SSFuncion, SSModalidad, ProgramaEducativo, SSSector, SSAmbito, Sexo, SSMovimientoEstatusProyecto, SSEditarEstatusModalService) {
        var vm = this;

        /* PARAMETROS */
        vm.sSProyecto = entity;
        vm.selectedTab = selectedTab;

        /* FORMULARIO */
        vm.ssareas = SSArea.query();
        vm.ssfuncions = SSFuncion.query();
        vm.ssmodalidads = SSModalidad.query();
    	vm.programasEducativos = ProgramaEducativo.all();
        vm.sssectores = SSSector.query();
        vm.ssambitos = SSAmbito.query();
        vm.sexos = Sexo.query();
        vm.periodoVigente = null;
        vm.semestres =  ["1", "2", "3", "4"];
        
        /* METODOS */
        vm.editarEstatus = editarEstatus;
        vm.agregarPerfil = agregarPerfil;
		vm.editarPerfil = editarPerfil;
        vm.removerPerfil = removerPerfil;
        vm.save = save;
        vm.clear = clear;
        
        $scope.$on('updateEstatusProyectoSuccess', function() {
        	SSProyecto.getSolicitud({id : $stateParams.id}).$promise.then(function (result) {
            	vm.sSProyecto = result;
            	loadProject();
        	});
        });
        
        loadProject();
        
        function loadProject(){
        	vm.isDisabled = false;
        	vm.showSeguimiento = true;        	
            SSMovimientoEstatusProyecto.getByProyecto({
            		idProyecto : vm.sSProyecto.id
            	}).$promise.then(function(result){
        		vm.sSMovimientoEstatusProyectos = result;
        	});
            $scope.active = vm.selectedTab;
        }
                
        function editarEstatus() {
        	SSEditarEstatusModalService.openCentral(vm.sSProyecto.id);
        }
        
		function save() {
			vm.isSaving = true;
			validarRespDeProyecto();
			validarUnidadReceptora();
			asignarAmbito();
			SSProyecto.updateByAdministrativo(vm.sSProyecto, onUpdateSuccess, onSaveError);
		}
        
		function onUpdateSuccess(result) {
			$scope.editForm.$setPristine();
			vm.isSaving = false;
			vm.sSProyecto = result;
		}

		function onSaveError() {
			vm.isSaving = false;
		}
		
		function asignarAmbito(){
			if (vm.sSProyecto.unidadesReceptoras[0].sector != null) {
				if (vm.sSProyecto.unidadesReceptoras[0].sector.id == 5)
					vm.sSProyecto.ambito = "INTERNO";
				else
					vm.sSProyecto.ambito = "EXTERNO";
			} else {
				vm.sSProyecto.ambito = null;
			}
		}
		
		
		function validarRespDeProyecto() {
			if (vm.sSProyecto.respDeProyectos.length == 1) {
				if (vm.sSProyecto.respDeProyectos[0].id == null) {
					if (vm.sSProyecto.respDeProyectos[0].nombres == null)
						vm.sSProyecto.respDeProyectos[0].nombres = '';
					if (vm.sSProyecto.respDeProyectos[0].primerApellido == null)
						vm.sSProyecto.respDeProyectos[0].primerApellido = '';
					if (vm.sSProyecto.respDeProyectos[0].segundoApellido == null)
						vm.sSProyecto.respDeProyectos[0].segundoApellido = '';
				}
			} else {
				console.log("respDeProyectos not properly setted.");
			}
		}

		function validarUnidadReceptora() {
			if (vm.sSProyecto.unidadesReceptoras.length == 1) {
				if (vm.sSProyecto.unidadesReceptoras[0].id == null) {
					if (vm.sSProyecto.unidadesReceptoras[0].institucion == null)
						vm.sSProyecto.unidadesReceptoras[0].institucion = '';
					if (vm.sSProyecto.unidadesReceptoras[0].unidadReceptora == null)
						vm.sSProyecto.unidadesReceptoras[0].unidadReceptora = '';
					if (vm.sSProyecto.unidadesReceptoras[0].dependencia == null)
						vm.sSProyecto.unidadesReceptoras[0].dependencia = '';
				}
			} else {
				console.log("unidadesReceptoras not properly setted.");
			}
		}
		
		
		function agregarPerfil() {
			if (vm.sSProyecto.perfils == null) {
				vm.sSProyecto.perfils = [];
			}			
		    var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/entities/s-s-proyecto/ss-perfil-proyecto/ss-perfil-proyecto.html',
                controller: 'SSPerfilProyectoController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    entity: function () {
                        return {
                            id: null,
                            programaEducativo: null,
                            solicitados: null,
            				actividads : [],
            				respDePrestadors : [],
                        };
                    }
                }
            });
		      modalInstance.result.then(function (newPerfil) {
			    	var perfilToSave = newPerfil;
			        SSProyecto.savePerfilByAdministrativo({
			        	perfil: perfilToSave, 
			        	proyecto: vm.sSProyecto.id},
			            function (result) {
							$scope.editForm.$setPristine();
							vm.isSaving = false;
							vm.sSProyecto = result;
			        });
		      }, function () {
		      });			
			
		}
		
		function editarPerfil(index, perfil) {
			var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/entities/s-s-proyecto/ss-perfil-proyecto/ss-perfil-proyecto.html',
                controller: 'SSPerfilProyectoController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    entity: function () {
                        return perfil;
                    }
                }
            });
		    modalInstance.result.then(function (editedPerfil) {
		    	var perfilToSave = editedPerfil;
		    	SSProyecto.savePerfilByAdministrativo({
		    		perfil: perfilToSave, 
		    		proyecto: vm.sSProyecto.id},
		    		function (result) {
		    			$scope.editForm.$setPristine();
		    			vm.isSaving = false;
			            vm.sSProyecto = result;
		    		});
			    }, function () {
			    });
		}

		function removerPerfil(index) {
			var perfilToDelete = vm.sSProyecto.perfils[index];
            SSProyecto.deletePerfilByAdministrativo({
            	sSProyecto: vm.sSProyecto.id, 
            	sSPerfil: perfilToDelete.id},
            	function () {
            		vm.sSProyecto.perfils.splice(index, 1);
            	}, function () {
		    	});
		}
        
        function clear () {
        	$state.go("ss-proyectos-central");
        }

    }
})();
